import { Component } from '@angular/core';
import { Carousel } from 'primeng/carousel';
import { ButtonModule } from 'primeng/button';

@Component({
    selector: 'app-carousel',
    standalone: true,
    imports: [Carousel, ButtonModule],
    templateUrl: './carousel.component.html',
    styleUrls: ['./carousel.component.less'],
})
export class CarouselComponent {
    products = [
        {
            image: '../../../assets/images/XENIAL-color.svg',
            leader: 'Tushar Dabhade',
            position: 'Sr Director, Software Development',
            businessArea: 'Catering',
            description:
                'In the fast-paced world of event planning, a clunky booking system kills momentum. CDS 	built us a sleek, user-friendly platform that handles ticket sales, seat selection, and real-time event updates seamlessly. During our biggest annual tournament, the system processed 10,000+ bookings without a hitch—no crashes, no delays. Their Agile team even added last-minute features like dynamic pricing for peak demand. Now, attendees rave about the booking experience, and we’ve seen a 20% surge in repeat registrations. For any event organizer, this is the tech edge you need to win.',
        },
        {
            image: '../../../assets/images/Sentral-color.svg',
            leader: 'Matthew Arnold',
            position: 'Development Manager',
            businessArea: 'Higher Education',
            description:
                'For years, our school struggled with siloed systems—enrollment, attendance, and resource booking were chaotic. CDS changed everything. Their team designed a campus management system that centralizes every process, from student onboarding to faculty scheduling. The intuitive dashboards gave us real-time insights, cutting administrative errors by 35% and freeing staff to focus on education, not paperwork. What stood out? Their commitment to understanding our unique academic workflows—no generic software, just a solution built for our community.',
        },
        {
            image: '../../../assets/images/ECSI-color.svg',
            leader: 'Edsel Lu',
            position: 'Director, Enterprise Architecture and Software Engineering',
            businessArea: 'Payment Solution',
            description:
                'During the implementation, their Agile development approach meant we could make adjustments on the fly as we discovered new requirements. Since going live, the efficiency of our lending operations has increased significantly. Loan processing time has been reduced by 40%, and the error rate in loan applications has dropped to an all-time low. For any educational institution looking to streamline campus lending, CDS is the partner you can trust.',
        },
        {
            image: '../../../assets/images/ezidebit-color.svg',
            leader: 'Partrick King',
            position: 'Chief Technology Officer - Payments',
            businessArea: 'Payment Solution',
            description:
                'CDS didn’t just ‘build software’—they architected a future-proof payment infrastructure. Their developers mastered complex API integrations, ensuring seamless transactions across 20+ geographies. Meanwhile, the security team embedded AI-driven fraud detection that cut chargeback rates by 18% in the first quarter post-launch.',
        },
        {
            image: '../../../assets/images/heartland-color.svg',
            leader: 'Adam Cole',
            position: 'Director, Software Development',
            businessArea: 'Human Capital Management',
            description:
                'I wanted to take a moment to celebrate all of the work that you have done over the last few weeks. Whether it’s working on an individual finding, doing research, working on the Macroscope-to-DevOps integration, or tackling several findings at once, all of you have played a part in this success so far. I’m genuinely impressed.',
        },
    ];
}
